module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921002651_T.d1ab6724.jpg";